// extracted by mini-css-extract-plugin
export default {"fileList":"style_fileList__eb8Bu","correctFilesList":"style_correctFilesList__Wn+9Q","correctFile":"style_correctFile__d4310","removeButton":"style_removeButton__XgRoc"};